/**
 * @constructor
 */
export default function Modal($body) {

    /**
     * Vars
     */
    let isOpened = false,
        isBusy = false,
        $html = $('html'),
        $header = $body.find('.js-header'),
        overlayMenuToggleClass = 'modal--visible';

    /**
     * Events
     */
    $body.find('.js-show-modal').on('click', toggle);
    $body.find('.js-close-modal').on('click', close);

    $body.on('keyup', function (e) {
        if (e.keyCode === 27 && isOpened === true && !isBusy) {
            close();
        }
    });

    /**
     * Toggle menu
     */
    function toggle(e) {
        if (isBusy) {
            return;
        }

        isOpened ? close(e) : show(e);
    }

    /**
     * Show
     */
    function show(e) {
        isBusy = true;
        let $toggler = $(e.currentTarget);
        let $modal = $($toggler.attr('href'));
        $modal.show();
        setTimeout(function() {
            $modal.addClass(overlayMenuToggleClass);
            isBusy = false;
        }, 50);
        $toggler.addClass('opened');
        $header.addClass('header--overlay-menu-opened');
        isOpened = true;
        if (window.fullpage_api) {
            window.fullpage_api.setAllowScrolling(!isOpened);
        }

        $html.addClass('modal-is-opened');
    }

    /**
     * Close
     */
    function close(e) {
        isBusy = true;
        let $toggler = $(e.currentTarget);
        let $modal = $toggler ? $($toggler.attr('href')) : $('.js-modal');
        $modal.removeClass(overlayMenuToggleClass);
        setTimeout(function() {
            $modal.hide();
            isOpened = false;
            isBusy = false;
            if (window.fullpage_api) {
                window.fullpage_api.setAllowScrolling(!isOpened);
            }
            $html.removeClass('modal-is-opened');
        }, 1000);
        $toggler.removeClass('opened');
        $header.removeClass('header--overlay-menu-opened');
    }
};